import React from 'react'

import filter from 'lodash/filter'

import HelpMenuItem from '../help-menu-item'
import ReportDownloadMenuItem from '../report-download-menu-item'
import AssociateToFolder from './MenuItems/AssociateToFolder'
import Edit from './MenuItems/Edit'
import MoveTo from './MenuItems/MoveTo'
import Remove from './MenuItems/Remove'
import RemovePageProfile from './MenuItems/RemovePageProfile'
import Statistics from './MenuItems/Statistics'

export const getMenuItems = (
  {
    id,
    slug,
    canManage,
    __typename,
    visibility,
    parent_folder_id,
    originalCreator,
  },
  removePositionTop,
  userIsCreator,
  path?,
  openReportDialogCallback?,
  hideIntercomForConsumer?
) => {
  const canEdit = canManage && !originalCreator
  const isFolderPage = path ? /^\/f\/[^/]+/.test(path) : false
  const isProfilePage = path ? /^\/profile(\/|$)/.test(path) : false
  const isCCPage = path?.includes('/cc/') ?? false
  // A workspace manager acts as the creator on elements created on behalf of
  // the owner; copies keep depending on the actual creator.
  const canActAsCreator = userIsCreator || (canManage && !originalCreator)

  return filter([
    removePositionTop &&
    canManage &&
    !isProfilePage &&
    (canActAsCreator || !isFolderPage) ? (
      <Remove id={id} key={`remove_${id}`} typename={__typename} />
    ) : null,
    userIsCreator && isProfilePage ? (
      <RemovePageProfile id={id} typename={__typename} />
    ) : null,
    Boolean(canEdit) ? <Edit key={`edit_${id}`} id={id} /> : null,
    canManage ? (
      <AssociateToFolder key={`associate_folder_${id}`} id={id} />
    ) : null,
    canActAsCreator && __typename !== 'Folder' ? (
      <MoveTo
        key={`move_${id}`}
        element={{ id, __typename, parent_folder_id, visibility }}
      />
    ) : null,
    canManage && isCCPage && (
      <ReportDownloadMenuItem
        key={`report_${id}`}
        openDialog={openReportDialogCallback}
      />
    ),
    canManage && <Statistics key={`statistics_${slug}`} slug={slug} />,

    !hideIntercomForConsumer && isCCPage && (
      <HelpMenuItem key={`help_${slug}`} />
    ),

    !removePositionTop &&
    canManage &&
    !isProfilePage &&
    (canActAsCreator || !isFolderPage) ? (
      <Remove id={id} key={`remove_${id}`} typename={__typename} />
    ) : null,
  ])
}
